import API from "../AxiosClient";
import ErrorHelper from "../../helpers/ErrorHelper";
import TokenDAO from "../../DAO/TokenDAO";

import axios from "axios";

export default class PrazoService {

	static async prazo(empresaPk, prazoPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const prazoResponse = await API.get(`/empresa/${empresaPk}/prazo/${prazoPk}/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return prazoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async prazosPorEmpresa(empresaPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const prazoResponse = await API.get(`/empresa/${empresaPk}/prazo/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return prazoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async criarPrazo(empresaPk, prazo) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/${empresaPk}/prazo/`, prazo, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async editarPrazo(empresaPk, prazoPk, prazo) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.put(`/empresa/${empresaPk}/prazo/${prazoPk}/`, prazo, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async desativacaoPrazo(empresaPk, prazoPk, desativar) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.patch(`/empresa/${empresaPk}/prazo/${prazoPk}/desativado/`, desativar, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async finalizarPrazo(empresaPk, prazoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/finalizado/`, {}, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async darCiencia(empresaPk, prazoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/ciente/`, {}, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async reabrir(empresaPk, prazoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/reabrir/`, {}, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async darComoCumprido(empresaPk, prazoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/cumprido/`, {}, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async historico(empresaPk, prazoPk, params = {}) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const historicoResponse = await API.get(`/empresa/${empresaPk}/prazo/${prazoPk}/timeline/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return historicoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async adicionarComentario(empresaPk, prazoPk, comentario) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const comentarioResponse = await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/comentario/`, comentario, {
				headers: {
					Authorization: token
				}
			});
			return comentarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async editarComentario(empresaPk, prazoPk, comentarioPk, comentario) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const comentarioResponse = await API.put(`/empresa/${empresaPk}/prazo/${prazoPk}/comentario/${comentarioPk}/`, comentario, {
				headers: {
					Authorization: token
				}
			});
			return comentarioResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async excluirComentario(empresaPk, prazoPk, comentarioPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			await API.delete(`/empresa/${empresaPk}/prazo/${prazoPk}/comentario/${comentarioPk}/`, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async getDataFim(empresaPk, data) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			const dataResponse = await API.post(`/empresa/${empresaPk}/prazo/dt_fim/`, data, {
				headers: {
					Authorization: token
				}
			});

			return dataResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async enviarAnexos(empresaPk, prazoPk, data) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			return await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/anexo/`, data, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async excluirAnexo(empresaPk, prazoPk, anexoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			return await API.delete(`/empresa/${empresaPk}/prazo/${prazoPk}/anexo/${anexoPk}/`, {
				headers: {
					Authorization: token
				}
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async anexos(empresaPk, prazoPk, params={}) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			const anexosResponse = await API.get(`/empresa/${empresaPk}/prazo/${prazoPk}/anexo/`, {
				params,
				headers: {
					Authorization: token
				}
			});

			return anexosResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async baixarAnexo(fileUrl) {
		try {
			return await axios.get(fileUrl, {
				responseType: 'blob'
			});
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async exportarExcelPrazos(empresaPk, params) {
		try {
			const token = `Token ${TokenDAO.get()}`;

			const prazoResponse = await API.get(`/empresa/${empresaPk}/prazo/`, {
				params,
				headers: {
					Authorization: token
				},
				responseType: 'blob'
			});

			return prazoResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
    }

	static async startContagemTempoTrabalhado(empresaPk, prazoPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			const timeworkedResponse = await API.post(`/empresa/${empresaPk}/prazo/${prazoPk}/timeworked/start/`, {}, {
				headers: {
					Authorization: token
				}
			});

			return timeworkedResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async pauseContagemTempoTrabalhado(empresaPk, prazoPk, timeworkedPk) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			const timeworkedResponse = await API.put(`/empresa/${empresaPk}/prazo/${prazoPk}/timeworked/${timeworkedPk}/pause/`, {}, {
				headers: {
					Authorization: token
				}
			});

			return timeworkedResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

	static async duplicarLote(empresaPk, data) {
		try {
			const token = `Token ${TokenDAO.get()}`;
			const duplicarResponse = await API.post(`/empresa/${empresaPk}/prazo/duplicar-lote/`, data, {
				headers: {
					Authorization: token
				}
			});

			return duplicarResponse.data;
		} catch (error) {
			throw ErrorHelper.apiHandlerError(error);
		}
	}

}
